import ApiKeyList from "./ApiKeyList";
import Logger from "../../../libs/Logger";
import ApiKeyHeader from "./ApiKeyHeader";

const ApiKeysLandingPage = () => {
  const log = new Logger({
    module: "Settings",
    component: "ApiKeysLandingPage",
  });
  return (
    <div className="xs:mx-auto lg:mx-0 lg:w-[70%] flex flex-col font-normal">
      <div className="">
        <div className="flex flex-col items-start">
          <ApiKeyHeader />
          <div className="w-full">
            <ApiKeyList />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiKeysLandingPage;
